"use client";

import { useEffect } from "react";

let lockDepth = 0;
let previousHtmlOverflow = "";
let previousBodyOverflow = "";

export function useBodyScrollLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) return;
    if (lockDepth === 0) {
      previousHtmlOverflow = document.documentElement.style.overflow;
      previousBodyOverflow = document.body.style.overflow;
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }
    lockDepth += 1;

    return () => {
      lockDepth = Math.max(0, lockDepth - 1);
      if (lockDepth === 0) {
        document.documentElement.style.overflow = previousHtmlOverflow;
        document.body.style.overflow = previousBodyOverflow;
      }
    };
  }, [locked]);
}